// Import all strategy templates
import strategy_v1_basic from './strategy_v1_basic.json';
import grid_trading_advanced from './grid_trading_advanced.json';
import gold from './gold.json';

// Raw templates object
export const strategyTemplates = {
  'strategy_v1_basic': strategy_v1_basic,
  'grid_trading_advanced': grid_trading_advanced,
  'gold': gold
};

// Helper function to enrich template with runtime fields
const enrichTemplate = (template, templateId) => {
  return {
    ...template,
    templateId: template.templateId || templateId,
    name: template.name || 'Unnamed Strategy',
    description: template.description || 'No description provided',
    strategyType: template.strategyType || 'basic',
    icon: template.icon || '🎯',
    version: template.version || 'v1',
    isMultiSymbol: template.isMultiSymbol !== undefined ? template.isMultiSymbol : false,
    parameters: template.parameters || []
  };
};

// Helper function to get a specific template by ID
export const getTemplateById = (templateId) => {
  const template = strategyTemplates[templateId];
  return template ? enrichTemplate(template, templateId) : null;
};

// Helper function to get all templates as an array with enriched fields
export const getAllTemplates = () => {
  return Object.entries(strategyTemplates).map(([key, template]) =>
    enrichTemplate(template, key)
  );
};

// Helper function to get template count
export const getTemplateCount = () => {
  return Object.keys(strategyTemplates).length;
};

export default strategyTemplates;
